import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useLanguage } from '../../context/LanguageContext';
import api from '../../utils/api';

const ContactForm = () => {
  const { t, currentLanguage } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    preferred_language: currentLanguage
  });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/api/contact', formData);
      toast.success(t('contact.form.success'));
      setFormData({ full_name: '', email: '', phone: '', subject: '', message: '', preferred_language: currentLanguage });
    } catch (error) {
      toast.error(error.message || t('contact.form.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="grid gap-3" onSubmit={submit}>
      <h3 className="text-2xl text-[#0f172a] font-semibold">{t('contact.title')}</h3>
      <input className="bg-white border border-[#cbd5e1] rounded-xl p-3 text-[#1e293b] placeholder-[#94a3b8]" placeholder={t('contact.form.name')} value={formData.full_name} onChange={(e) => setFormData({ ...formData, full_name: e.target.value })} required />
      <input className="bg-white border border-[#cbd5e1] rounded-xl p-3 text-[#1e293b] placeholder-[#94a3b8]" placeholder={t('contact.form.email')} type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} required />
      <input className="bg-white border border-[#cbd5e1] rounded-xl p-3 text-[#1e293b] placeholder-[#94a3b8]" placeholder={t('contact.form.phone')} value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
      <input className="bg-white border border-[#cbd5e1] rounded-xl p-3 text-[#1e293b] placeholder-[#94a3b8]" placeholder={t('contact.form.subject')} value={formData.subject} onChange={(e) => setFormData({ ...formData, subject: e.target.value })} />
      <textarea className="bg-white border border-[#cbd5e1] rounded-xl p-3 text-[#1e293b] placeholder-[#94a3b8]" rows={5} placeholder={t('contact.form.message')} value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} required />
      <button className="btn-primary" disabled={loading}>{loading ? t('contact.form.sending') : t('contact.form.submit')}</button>
    </form>
  );
};

export default ContactForm;
